<template>
  <div>
    <el-dialog
  :title="title"
  :visible.sync="centerDialogVisible"
  width="40%"
  center>
  <div style="text-align:center">
    <span class="tetxp">{{$t('lang.softwarepackage.VisibleUser')}}：</span>
  <el-select v-model="spPermission" :placeholder="$t('lang.softwarepackage.PLEASE')" class="admininput" size="mini">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
  </div>
  <div style="text-align:center" v-if="spPermission>0">
    <span class="tetxp">{{$t('lang.softwarepackage.DesignatedCustomer')}}：</span>
  <el-select v-model="OptionsValue" :placeholder="$t('lang.softwarepackage.PLEASE')" filterable class="admininput" size="mini">
    <el-option
      v-for="item in list"
      :key="item.c_id"
      :label="item.c_name"
      :value="item.c_id">
    </el-option>
  </el-select>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button size="mini" @click="centerDialogVisible = false">{{$t('lang.softwarepackage.Cancel')}}</el-button>
    <el-button size="mini" type="primary" @click="SubmitSet">{{$t('lang.softwarepackage.Confirm')}}</el-button>
  </span>
</el-dialog>
  </div>
</template>
<script>
import { getCustomerList } from '@/api/softwarepackage'
export default {
  props:['Show','title','spPermission'],
  data(){
    return{
      centerDialogVisible:false,
      list:[],
      C_idList:[],
      options:[{
        label:this.$t('lang.softwarepackage.AllUsers'),
        value:-1
      },
      {
        label:this.$t('lang.softwarepackage.SystemAdministrator'),
        value:0
      },
      {
        label:this.$t('lang.softwarepackage.DesignatedCustomer'),
        value:1
      }
      ],
      OptionsValue:''
    }
  },
  mounted(){
    //获取所有客户列表
    getCustomerList()
    .then((res)=>{
      this.list=res.data.data.list
    })
  },
  methods:{
    //提交修改触发父组件
    SubmitSet(){
      //如果选中指定客户并且指定客户未做出选择
      if(this.spPermission>0&&!this.OptionsValue){
        this.$message({
          message: this.$t('lang.softwarepackage.Pleaseselectacustomer'),
          type: 'warning'
        })
        return
      }
      //提交权限修改
      this.$emit('SubmitModify',this.spPermission>0?this.OptionsValue:this.spPermission)
      this.centerDialogVisible=false
    }
  },
  watch:{
    Show:{
      handler(newValue,oldValue){
        if(!this.centerDialogVisible&&newValue){
        this.centerDialogVisible=true
        }
      }
    },
    //监听弹出框隐藏通知父组件
    centerDialogVisible:{
      handler(newValue,oldValue){
        this.$emit('DialogResponse',newValue)
      }
    },
    //监听可见用户值变化
    spPermission:{
      handler(newValue,oldValue){
        console.log(newValue)
        //如果可见用户下拉框大于0 当前选中指定客户
        if(newValue>0){
          //改变下拉框的值
          this.options[2].value=newValue
          //如果可见用户下拉框值大于1，代表指定了客户
          if(newValue>1){
            //给指定客户下拉框赋值
            this.OptionsValue=newValue
          }
        }
        else {
          this.OptionsValue=''
        }
      }
    }
  }
}
</script>
<style scoped>
.Tree-Con{
  height: 60vh;
  overflow: scroll;
}
.Select-List{
  width: 4rem;
  margin: 0 auto;
}
.tetxp {
  display: inline-block;
  width: 4rem;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  text-align: right;
}
.admininput {
  display: inline-block;
  width: 4rem;
  margin: 0.2rem;
}
</style>
